import ReactGA from "react-ga";
import { useEffect } from "react";

export const RouteElementWrapper = ({ children }) => {
  return <>{children}</>;
};
